export default "__VITE_ASSET__C4HON19O__"